<template>
  <v-container class="container pt-5">
    <h2>Wunschdienstplan</h2>
    <v-text-field prepend-icon="mdi-pencil" class="mb-4" variant="underlined" v-model="title" clearable label="Titel"></v-text-field>
    <VDateInput variant="underlined" label="Deadline"
                cancel-text="Abbrechen"
                ok-text="OK"
                v-model='deadline' />
    <v-row class="d-flex justify-center">
      <v-btn-toggle mandatory  variant="outlined" v-model="selectedDate" class="mb-1">
        <v-btn width="*" variant="plain" color="primary" value="von">von</v-btn>
        <v-btn width="*" variant="plain" color="primary" value="bis">bis</v-btn>
      </v-btn-toggle>
    </v-row>
    <v-calendar
        class="mb-2"
        transparent
        expanded
        borderless
        mode="dateTime"
        :attributes="attributes"
        @dayclick="dayClick"
    />
    <VCheckbox class="mb-2 v-checkbox--default" label="Gesperrt" v-model="locked"></VCheckbox>
    <VCheckbox class="mb-2 v-checkbox--default" label="Versteckt" v-model="hidden"></VCheckbox>
    <v-row class="d-flex justify-center mt-4 mb-4">
      <v-btn color="secondary" @click="onCancel" class="mb-2">Zurück</v-btn>
      <v-btn color="primary" @click="onSave" class="ml-2">Speichern</v-btn>
    </v-row>
  </v-container>
</template>

<script>
import {ref, watch, computed} from "vue";
export default {
  components: {
    VCheckbox: () => import('@new-mg/vuetify-new-theme'),
  },
  props: {
    period: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const localId = ref(props.period ? props.period.id : undefined);
    const id = computed(() => {
      
      if(localId.value) {
        return localId.value;
      }
      else if(startDate.value && endDate.value) {
        return formatDateToYYYYMMDD(startDate.value);
      }
    })
    const startDate = ref(props.period ? props.period.startDate.toDate() : null);
    const endDate = ref(props.period ? props.period.endDate.toDate() : null);
    const selectedDate = ref('von');
    const title = ref(props.period ? props.period.title : '');
    const locked = ref(props.period ? props.period.locked : false);
    const hidden = ref(props.period ? props.period.hidden : true);
    const deadline = ref(props.period ? props.period?.deadline?.toDate() : new Date());
    
    const attributes = ref([
      {
        highlight: 'green',
        dates: [[startDate.value, endDate.value]],
      },
    ]);

    function formatDateToYYYYMMDD(date) {
      const year = date.getFullYear(); 
      const month = String(date.getMonth() + 1).padStart(2, "0"); 
      const day = String(date.getDate()).padStart(2, "0"); 

      return `${year}${month}${day}`;
    }
    
    const refreshAttributes = () => {
      attributes.value[0].dates = [[startDate.value, endDate.value]];
    };

    watch(startDate, refreshAttributes);
    watch(endDate, refreshAttributes);

    const dayClick = (date) => {
      if(selectedDate.value === 'von') {
        startDate.value = date.date;
        
        if(endDate.value === null) {
          endDate.value = startDate.value;
        }
        
        selectedDate.value = 'bis';
      } else {
        endDate.value = date.date;
      }
    };

    return { id, deadline, attributes, selectedDate, dayClick, title,locked, hidden, startDate, endDate};
  },
  methods: {
    onSave() {
      this.$emit('wishperiod-save', 
          { id: this.id, 
            startDate: this.startDate, 
            endDate: this.endDate, locked: this.locked,
            hidden: this.hidden,
            title: this.title,
            deadline: this.deadline});
    },
    onCancel() {
      this.$emit('wishperiod-back', false);
    },
  },
};
</script>

<style scoped>
.container {
  border-radius: 5px;
  background: white;
}
</style>